import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import { secretKey } from "./data";
import LoadingPopup from "./loading";

const MySwal = withReactContent(Swal2);

const Statistics = (props) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState("");
  const [users, setUsers] = useState([]);
  const [sources, setSources] = useState([]);
  const [statuses, setStatuses] = useState([]);

  const onlyUnique = (value, index, array) => {
    return array.indexOf(value) === index;
  };

  const getData = () => {
    var arr = [];
    props.leads.map((l) => {
      if (arr.filter((a) => +a === +l.seller).length === 0) {
        arr.push(l.seller);
      }
    });
    var arr2 = [];
    arr.map((a2) => {
      if (a2) {
        var obj = {
          id: a2,
          name: props.users.filter((u2) => +u2.id === +a2)[0].name,
        };
        arr2.push(obj);
      }
    });
    setUsers(arr2);
    setUser(arr2[0].id);

    var arr = [];

    props.leads.map((el) => {
      if (arr.filter((l) => l === el.status).length === 0) {
        arr.push(el.status);
      }
    });

    setStatuses(arr);

    var arr = [];

    props.leads.map((el) => {
      if (arr.filter((l) => l === el.source).length === 0) {
        arr.push(el.source);
      }
    });

    setSources(arr);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: "8vh",
          width: "60vw",
          height: "40vh",
          overflowY: "scroll",
          backgroundColor: "white",
          borderRadius: "15px",
          boxShadow: "8px 8px 24px 0px rgba(66, 68, 90, 1)",
          padding: "1%",
          zIndex: "10",
        }}
      >
        <div style={{ display: "flex", marginBottom: "3vh" }}>
          <div
            style={{
              width: "85%",
              textAlign: "left",
              fontWeight: "600",
              fontSize: "1.5vw",
            }}
          >
            STATYSTYKI
            <br />
          </div>
          <div style={{ width: "15%" }}>
            <button
              className="loginButtonLogin"
              value="yes"
              style={{
                margin: "0",
                backgroundColor: "navy",
                borderColor: "navy",
                width: "100%",
              }}
              onClick={props.close}
            >
              X
            </button>
          </div>
        </div>
        <div style={{ textAlign: "left" }}>
          <p
            style={{
              textAlign: "left",
              fontSize: "1vw",
              margin: "0",
              marginBottom: "10px",
            }}
          >
            wybierz użytkownika
          </p>
          <select
            value={user}
            onChange={(e) => {
              setUser(e.target.value);
            }}
          >
            {users ? (
              users.map((u) => (
                <option key={u.id} value={u.id}>
                  {u.name}
                </option>
              ))
            ) : (
              <option key={0} value={0}>
                Ładuje...
              </option>
            )}
          </select>
        </div>
        {user.length > 0 ? (
          <div style={{ textAlign: "left" }}>
            {sources.map((el) => (
              <>
                <p style={{ fontWeight: "600" }}>{el}</p>
                {statuses.map((el2) => (
                  <p style={{ marginLeft: "20px" }}>
                    {el2}:{" "}
                    <span style={{ fontWeight: "600" }}>
                      {
                        props.leads.filter(
                          (el3) =>
                            el3.status === el2 &&
                            el3.source === el &&
                            +el3.seller === +user
                        ).length
                      }{" "}
                      szt.
                    </span>
                  </p>
                ))}
              </>
            ))}
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default Statistics;
